import {BreakpointSize} from './pageBreakpoints';
import {viewportSize} from './viewportSize';

export const currentDevice = (devices: BreakpointSize[]): BreakpointSize => {
  return (
    [...devices].reverse().find(device => viewportSize.isGreater(device)) ||
    devices[0]
  );
};
